const calculateLoadingColors = (inputColor: { r: number; g: number; b: number }) => {
  let r = Math.floor(inputColor.r / 3)
  let g = Math.floor(inputColor.g / 3)
  let b = Math.floor(inputColor.b / 3)

  let dr = Math.floor(inputColor.r / 6)
  let dg = Math.floor(inputColor.g / 6)
  let db = Math.floor(inputColor.b / 6)

  const highlightColor = `rgba(${r}, ${g}, ${b}, 1)`
  const darkBrandColor = `rgba(${dr}, ${dg}, ${db}, 1)`

  return {
    highlightColor,
    darkBrandColor,
  }
}

export default calculateLoadingColors
